"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsNull_1 = __importDefault(require("../typeAssertions/valueIsNull"));
const valueIsUndefined_1 = __importDefault(require("../typeAssertions/valueIsUndefined"));
const jsonStringifyRecursive = (data) => {
    if ((0, valueIsUndefined_1.default)(data)) {
        return 'undefined';
    }
    if ((0, valueIsNull_1.default)(data)) {
        return 'null';
    }
    let cache = [];
    const stringData = JSON.stringify(data, (key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (cache === null || cache === void 0 ? void 0 : cache.includes(value)) {
                return '[Recursive]';
            }
            if (cache) {
                cache.push(value);
            }
        }
        return value;
    });
    cache = undefined;
    return stringData;
};
exports.default = jsonStringifyRecursive;
